import { Component } from 'react';

export default class ContactUs extends Component {

    render() {

        return (
            <div className='ContactUs'>
                <div className='ContactUs_Title'>
                    Connect With Us ! ! !
                </div>
                <div className='ContactUs_FormInfo'>
                    Request A Quote
                    <div className='ContactUs_FormBlock1'>
                        <input placeholder='Enter Your Name'/>
                        <input placeholder='Enter Your Email'/>
                    </div>
                    <div className='ContactUs_FormDesc'>
                        <textarea placeholder='Enter Your Work Description'/>
                    </div>
                    <button className='ContactUs_Button'>Submit Request</button>
                </div>
            </div>
        );
    }
}
